import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    token: null,
    isLoading: false,
};
export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setToken: (state, action) => {
            // eslint-disable-next-line no-param-reassign
            state.token = action.payload;
        },
        resetToken: (state) => {
            // eslint-disable-next-line no-param-reassign
            state.token = null;
        },
        setIsLoading: (state, action) => {
            // eslint-disable-next-line no-param-reassign
            state.isLoading = action.payload;
        },
    },
});
export const { setToken, resetToken, setIsLoading } = authSlice.actions;
export const selectToken = (state) => state.auth.token;
export default authSlice.reducer;
